import React from 'react';
import classNames from 'classnames';

import {
    translateAchievementLevel,
    findAchievement,
} from '../utils.js';
import Graph from './Graph.js';


export default function ({allSkillData}) {

    const achievement_data = findAchievement(allSkillData);
    // console.log('achievement_data', achievement_data);
    const top_skills = achievement_data.top_skills;

    function renderTopSkills() {
        const skills = top_skills.map((row, k) => {
            const class_names = classNames('top-skills-item-level', `top-skills-item-level-${row.achievement_level}`);
            return (
                <div key={k} className="top-skills-item flex-row flex-gap-10 flex-v-center">
                    <div className="top-skills-item-name">
                        {row.practice_skill_name}
                    </div>
                    <div className={class_names}>
                        {translateAchievementLevel(row.achievement_level)}
                    </div>
                </div>
            );
        });
        return (
            <div className="tsp-top-skills">
                {skills}
            </div>
        );
    }

    if (!allSkillData.length) {
        return null;
    }

    return (
        <div className="tsp-achievement">
            <div className="tsp-header">
                Skill Achievement
            </div>
            <div className="flex-row flex-gap-25">
                {renderTopSkills()}
                <Graph
                    skills={top_skills}
                />
            </div>
        </div>
    );
}